import { render, staticRenderFns } from "./RunnitsSubscriptionCard.vue?vue&type=template&id=d3795aa8&scoped=true"
import script from "./RunnitsSubscriptionCard.vue?vue&type=script&lang=ts"
export * from "./RunnitsSubscriptionCard.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsSubscriptionCard.vue?vue&type=style&index=0&id=d3795aa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3795aa8",
  null
  
)

export default component.exports